import { render, staticRenderFns } from "./SpecificationImportPage.vue?vue&type=template&id=c0d3ee50&scoped=true&lang=pug&"
import script from "./SpecificationImportPage.vue?vue&type=script&lang=js&"
export * from "./SpecificationImportPage.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationImportPage.vue?vue&type=style&index=0&id=c0d3ee50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d3ee50",
  null
  
)

export default component.exports